'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = require('./mutation-types');

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SKIN, function (state, payload) {
  state.skin = payload;
}), (0, _defineProperty3.default)(_mutations, types.TOKEN, function (state, payload) {
  state.token = payload;
}), (0, _defineProperty3.default)(_mutations, types.MENUOPENNAME, function (state, payload) {
  state.menuOpenName = payload;
}), (0, _defineProperty3.default)(_mutations, types.MENUACTIVENAME, function (state, payload) {
  state.menuActiveName = payload;
}), (0, _defineProperty3.default)(_mutations, types.PAGE_SIZE, function (state, payload) {
  state.pageSize = payload;
}), (0, _defineProperty3.default)(_mutations, types.MODEL_DISABLED, function (state, payload) {
  state.modelDisabled = payload;
}), (0, _defineProperty3.default)(_mutations, types.CRUMBS_LIST, function (state, payload) {
  if (Array.isArray(payload)) {
    state.crumbsList = payload;
  } else if (Object.prototype.toString.call(payload) === '[object Object]') {
    state.crumbsList.splice(payload.start, payload.count);
  }
}), (0, _defineProperty3.default)(_mutations, types.MENU_LIST, function (state, payload) {
  state.menuList = payload;
}), (0, _defineProperty3.default)(_mutations, types.BIND_PHONE, function (state, payload) {
  state.bindPhone = payload;
}), (0, _defineProperty3.default)(_mutations, types.HELP_SELECTED, function (state, payload) {
  state.helpSelected = payload;
}), (0, _defineProperty3.default)(_mutations, types.USER_CHANGE_INFO, function (state, payload) {
  state.userChangeInfo = payload;
}), (0, _defineProperty3.default)(_mutations, types.FLUSHCONTENT, function (state, payload) {
  state.flushContent = payload;
}), (0, _defineProperty3.default)(_mutations, types.LOGIN_SUCCESS_NOTIFY, function (state, payload) {
  state.loginSuccessNotify = payload;
}), _mutations);
exports.default = mutations;